<div class="dialog-content-max"   *ngIf="!isView">
    <form [formGroup]="myForm">

      
  
    <div class="formgrid grid">
        <div class="field col-4">
            <div class="form-group">
                <label for="fromdate" class="required-label">From Date <span>*</span></label><br/>
                <p-calendar 
                [(ngModel)]="fromDate" 
                formControlName="fromdate" 
                appendTo="body" 
                [showIcon]="true" 
                dateFormat="dd-MM-yy" 
                (onClear)="onClear()"
                placeholder="Choose Date"  
                todayButtonLabel="Today" 
                name="fromdate" 
                id="fromdate" 
                styleClass="pcalendar-readonly" 
                (onSelect)="validateDates()"
                [showButtonBar]="true"
                [readonlyInput]="true" 
                [showOtherMonths]="true" 
                [selectOtherMonths]="true"
                >
              </p-calendar><br/>

              <span class="errormessage" style="display: block;"
              *ngIf="myForm.get('fromdate').invalid  && (myForm.get('fromdate').touched || myForm.get('fromdate').dirty)">
              {{getErrorMessage(myForm,validation_message,'fromdate')}}
              </span>
              </div>
        </div>
               

        <div class="field col-4">
            <div class="form-group">
                <label for="todate" class="required-label">To Date <span>*</span></label><br/>
                <p-calendar 
                [(ngModel)]="toDate" 
                formControlName="todate" 
                inputId="todate" 
                appendTo="body" 
                [showIcon]="true" 
                dateFormat="dd-MM-yy" 
                (onClear)="onClear()"
                placeholder="Choose Date"  
                todayButtonLabel="Today" 
                name="todate" 
                id="todate" 
                styleClass="pcalendar-readonly" 
                (onSelect)="validateDates()"
                [showButtonBar]="true"
                [readonlyInput]="true" 
                [showOtherMonths]="true" 
                [selectOtherMonths]="true"                >
              </p-calendar><br/>
              <span class="errormessage" style="display: block;"
              *ngIf="myForm.get('todate').invalid  && (myForm.get('todate').touched || myForm.get('todate').dirty)">
              {{getErrorMessage(myForm,validation_message,'todate')}}
              </span>
              <!-- Validation message -->
              <div class="validation-space">
                <span *ngIf="myForm.get('todate').valid && errorDIsplay" style="color: red;">From Date can't be greater than To Date</span>
              </div>
            </div>
        </div>

        <div class="field col-2">
            <div class="form-group">
            <label for="activeflag" class="required-label">Active Flag?<span>&nbsp;*</span></label>
            <p-dropdown [options]="activeFlag" inputId="activeflag" [filter]="true" appendTo="body" name="activeflag"
              optionLabel="labelname" optionValue="value" formControlName="activeflag" placeholder="Choose Yes or No"
              ></p-dropdown>
              <span class="errormessage"
              *ngIf="myForm.get('activeflag').invalid && (myForm.get('activeflag').touched  || myForm.get('activeflag').dirty)">
              {{getErrorMessage(myForm,validation_message,'activeflag')}}
            </span>
          </div>
        </div>

    </div>


    <div class="formgrid grid">
       <div class="field col-12">
          <div class="form-group">
            <label for="messagename" class="required-label">Login Page Message
              <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 2000 chars)</span></label>
            <p-editor pInputTextarea class="form-control" type="text" placeholder="Enter Login Page Message"
                formControlName="messagename" [readonly]="onlyView" name="messagename" maxlength="2000"
                [style]="{ height: '270px' }" />
          <span class="errormessage"
            *ngIf="myForm.get('messagename').invalid && (myForm.get('messagename').touched || myForm.get('messagename').dirty)">
            {{getErrorMessage(myForm ,validation_message,'messagename')}}
          </span>
        </div>
      </div>
    </div>

<!--
      <div class="formgrid grid">
        <div class="col-12 lg:col-12 md:col-12 sm:col-12">
          <div class="form-group">
            <p-editor #formField id="helptext" formControlName="helptext" 
            [style]="{ height: '320px' }" (onTextChange)="updateCharacterCount()">
            </p-editor>
            <div class="text-right">
            <small>{{ characterCount }} characters</small>
            </div>
              <span class="errormessage"
            *ngIf="myForm.get('helptext').invalid && myForm.get('helptext').touched ">
            {{getErrorMessage(myForm ,validation_message,'helptext')}}
          </span>
        </div>
      </div>
      </div>
  
-->

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
        <p-button class="m-1" *ngIf="!isView" label="{{saveTitle}}" styleClass="customesave" (click)="add()"></p-button>
      </div>
    
  
    </form>
  
  </div>
  






  <div class="dialog-content-max"   *ngIf="isView">
    <form [formGroup]="myForm">
  
    <div class="formgrid grid">
        <div class="field col-4">
            <div class="form-group">
                <label for="fromdate" class="required-label">From Date..</label><br/>
                <input  [readonly]="true" class="form-control" type="text" formControlName="fromdate"/>
              </div>
        </div>
        <div class="field col-4">
          <div class="form-group">
              <label for="todate" class="required-label">To Date</label><br/>
              <input  [readonly]="true" class="form-control" type="text" formControlName="todate"/>
          </div>
      </div>
      <div class="field col-4">
        <div class="form-group">
            <label for="activeflag" class="required-label">Active Flag</label><br/>
            <input  [readonly]="true" class="form-control" type="text" formControlName="activeflag"/>
        </div>
    </div>
    </div>
  

    <div class="formgrid grid">
       <div class="field col-12">
          <div class="form-group">
            <label for="messagename"  class="required-label">Login Page Message</label>
            <p-editor pInputTextarea class="form-control" type="text" style="height:auto !important"
            formControlName="messagename" [readonly]="true" name="messagename" 
              />

        </div>
      </div>
    </div>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
      </div>
    
  
    </form>
  
  </div>
  

